import styled from '@emotion/styled';
import { PropsWithChildren } from 'react';

const GroupContainer = styled.div`
  border: solid 1px var(--fett-border-default);
  > header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 48px;
    padding: 0 16px;
    border-bottom: solid 1px var(--fett-border-default);
    > h3 {
      position: relative;
      margin-bottom: 0;
      font-size: 14px;
      text-indent: 8px;
      &::before {
        display: inline-block;
        content: '';
        position: absolute;
        top: 5px;
        left: 0;
        width: 3px;
        height: 12px;
        background: var(--ant-primary-color);
      }
    }
  }
`;
interface GroupLayoutProps {
  title: string;
  className?: string;
  style?: React.CSSProperties;
}
function GroupLayout(props: PropsWithChildren<GroupLayoutProps>) {
  const { title, children, ...rest } = props;
  return (
    <GroupContainer {...rest}>
      <header>
        <h3>{title}</h3>
      </header>
      {children}
    </GroupContainer>
  );
}
export default GroupLayout;
